import React from 'react';
export const ImageSection = () => {
  return <section className="bg-teal-800 py-12" data-id="element-196">
      <div className="container mx-auto px-4 max-w-xl" data-id="element-197">
        <div className="flex justify-center" data-id="element-198">
          
        </div>
      </div>
    </section>;
};